import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface ProcessingMessageProps {
  title: string;
  message: string;
  showEmailNotification?: boolean;
}

export const ProcessingMessage: FC<ProcessingMessageProps> = ({
  title,
  message,
  showEmailNotification = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="bg-day-light-3 w-full flex flex-col items-center justify-center min-h-[60vh] rounded-lg">
      <div className="text-day-neutral-subtle text-xl font-medium">{title}</div>
      <p className="text-night-light-5 mt-2">{message}</p>
      {showEmailNotification && (
        <p className="text-night-light-5 mt-2">
          {t(
            'package-creation.reports.email-notification',
            '📧 You will receive an email notification once processing is complete.',
          )}
        </p>
      )}
    </div>
  );
};
